import React from "react";
import { ReactComponent as Logo } from "../../../assets/icon/something-wrong.svg";

const ErrorIcon = () => {
  return <Logo />;
};

export default ErrorIcon;
